// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_problem_body2 = /** @type {(inputs: {}) => string} */ () => {
	return `Modern life put concrete, tile, and asphalt beneath your feet. Conventional shoes sealed them in rigid boxes. Your joints take the impact. Your stabilising muscles atrophy. Back pain, knee pain, and fatigue become background noise you learn to live with.`
};

const el_tech_problem_body2 = /** @type {(inputs: {}) => string} */ () => {
	return `Η σύγχρονη ζωή έβαλε σκυρόδεμα, πλακάκια και άσφαλτο κάτω από τα πόδια σας. Τα συμβατικά παπούτσια τα σφράγισαν σε άκαμπτα κουτιά. Οι αρθρώσεις σας δέχονται το χτύπημα. Οι σταθεροποιητικοί μύες ατροφούν. Πόνοι στη μέση, στα γόνατα και κόπωση γίνονται μέρος της καθημερινότητας.`
};

const ru_tech_problem_body2 = /** @type {(inputs: {}) => string} */ () => {
	return `Современная жизнь подложила под ваши ноги бетон, плитку и асфальт. Обычная обувь заковала их в жёсткие коробки. Суставы принимают удар. Стабилизирующие мышцы атрофируются. Боли в спине, коленях и усталость становятся фоновым шумом, с которым вы учитесь жить.`
};

const he_tech_problem_body2 = /** @type {(inputs: {}) => string} */ () => {
	return `החיים המודרניים שמו בטון, אריחים ואספלט מתחת לרגליכם. נעליים רגילות כלאו אותן בקופסאות נוקשות. המפרקים סופגים את המכה. שרירי הייצוב מתנוונים. כאבי גב, כאבי ברכיים ועייפות הופכים לרעש רקע שלומדים לחיות איתו.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_problem_body2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_problem_body2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_problem_body2", locale)
	if (locale === "en") return en_tech_problem_body2(inputs)
	if (locale === "el") return el_tech_problem_body2(inputs)
	if (locale === "ru") return ru_tech_problem_body2(inputs)
	if (locale === "he") return he_tech_problem_body2(inputs)
	return "tech_problem_body2"
};